import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BackendService, HttpOptions } from '@ipg/ngx-frontend-toolset';
import { Group } from '../models/group.model';
import { SharedMediaResponse } from '../models/media.model';
import { ReferenceGroup } from '../views/media/components/media-references-dialog/media-references-dialog.component';

@Injectable({
  providedIn: 'root',
})
export class ShareService {
  private readonly _backend = inject(BackendService);

  share(mediaId: string, options?: HttpOptions): Observable<void> {
    return this._backend.post(`/media/${mediaId}/share`, null, options);
  }

  unshare(mediaId: string, options?: HttpOptions): Observable<void> {
    return this._backend.delete(`/media/${mediaId}/share`, options);
  }

  getSharedMedia(options?: HttpOptions): Observable<SharedMediaResponse[]> {
    return this._backend.get(`/media/shared`, options);
  }

  getSharedGroups(options?: HttpOptions): Observable<Group[]> {
    return this._backend.get(`/media/shared/groups`, options);
  }

  bulkShare(mediaIds: string[], options?: HttpOptions): Observable<void> {
    return this._backend.post(`/media/share/bulk`, { mediaIds }, options);
  }

  bulkUnshare(mediaIds: string[], options?: HttpOptions): Observable<void> {
    return this._backend.post(`/media/unshare/bulk`, { mediaIds }, options);
  }

  getReferences(mediaId: string, options?: HttpOptions): Observable<ReferenceGroup[]> {
    return this._backend.get(`/media/${mediaId}/references`, options);
  }

  shareGroup(groupId: string, options?: HttpOptions): Observable<void> {
    return this._backend.post(`/groups/${groupId}/share`, null, options);
  }

  unshareGroup(groupId: string, options?: HttpOptions): Observable<void> {
    return this._backend.delete(`/groups/${groupId}/share`, options);
  }

  getSharedGroupsTree(options?: HttpOptions): Observable<Group[]> {
    return this._backend.get(`/media/shared/groups`, {
      ...options,
      params: { ...options?.params, tree: 'true' },
    });
  }
}
